import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledPayElement = styled.div`
    ${userPanelElementStyles};
`;
